import { lazy, useState, Suspense } from 'react';

import { useHotkeys } from 'react-hotkeys-hook'

import { useInjectReducer, useInjectSaga } from '@webapp/utils'
import { RESTART_ON_REMOUNT } from '@webapp/utils/constants'
import { reducer } from './stores/reducer'
import sagas from './stores/sagas'

const ProcurifyDevToolsChunk = lazy(() =>
  import('./ProcurifyDevTools').then(({ ProcurifyDevTools }) => ({
    default: ProcurifyDevTools,
  }))
)

export const ProcurifyDevToolsLoadable = () => {
  const [show, setShow] = useState(false)

  useInjectReducer({ key: 'dev', reducer })
  useInjectSaga({
    key: 'dev',
    saga: sagas,
    mode: RESTART_ON_REMOUNT,
  })

  useHotkeys(
    'meta+k',
    () => {
      setShow(true)
    },
    {
      enableOnFormTags: ['input'],
    }
  )

  return (
    <Suspense fallback={null}>
      {show && <ProcurifyDevToolsChunk />}
    </Suspense>
  );
}
